import { prepareUrlParamsForFilterProducts } from '@/utils/api-drive-params'
export default class ProductList {
  // path definition
  path(shopId, categoryId, filterList = null, page = null, sortBy = null) {
    if (filterList || page || sortBy) {
      return prepareUrlParamsForFilterProducts('DP', null, filterList, page, sortBy, shopId, categoryId)
    } else {
      return `/api/magasins/${shopId}/navigation-content/C-${categoryId}`;
    }
  }

  constructor(http) {
    this.http = http;
  }

  async products(params) {
    const response = await this.http.get(this.path(params.shopId, params.categoryId, params.filterList))
    return response;
  }

  async productsFiltered(params) {
    const response = await this.http.get(this.path(params.shopId, params.categoryId, params.filterList, params.page, params.sortBy))
    return response;
  }
}
